import React from 'react'
import styled from 'styled-components'

import { SmileIcon } from '@root/shared/ui-kit/icons'
import { Popover } from '@root/shared/ui-kit/popover'

import { EmojiPicker } from '../emoji-picker'

type TextareaEmojisProps = {
  value: string
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
}

export const TextareaEmojis = ({ value, onChange }: TextareaEmojisProps) => {
  const [showEmojiPicker, setShowEmojiPicker] = React.useState(false)

  return (
    <Root
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
    >
      <Popover
        open={showEmojiPicker}
        onOpenChange={setShowEmojiPicker}
        align="start"
        side="bottom"
        content={
          <EmojiPicker
            emojiButtonColors={['var(--primary-9)']}
            onEmojiSelect={(x: { native: string }) => {
              const prevValue = value.toString()
              onChange({
                target: { value: prevValue + x.native },
              } as React.ChangeEvent<HTMLTextAreaElement>)
            }}
          />
        }
      >
        <ToolButton>
          <SmileIcon width={15} height={15} />
        </ToolButton>
      </Popover>
    </Root>
  )
}

const Root = styled.div``

const ToolButton = styled.span`
  color: var(--text-8);

  display: grid;
  grid-auto-flow: column;
  gap: 3px;
  cursor: pointer;

  transition: color 0.15s ease-in-out;

  &:hover {
    color: var(--text-11);
  }
`
